import React from "react"
import { Grid, FormControl, Select, MenuItem } from "@material-ui/core"
import { ContactsFiltersConditions } from "@/protocols/ClientCatalogFilterProtocol"
import { WABAChannelChatCommunicationPermissionStatusOnFilter } from "@/@integrations/WABA/protocols/wabaChannelChatCommunicationPermission"

type WABACommunicationPermissionFilterConditionProps = {
	condition: ContactsFiltersConditions<"contact_waba_communication_permission">
	onChange: (condition: ContactsFiltersConditions<"contact_waba_communication_permission">) => void
}

const ACCEPTED_WABA_COMMUNICATION_PERMISSION_STATUSES: WABAChannelChatCommunicationPermissionStatusOnFilter[] = [
	"active",
	"paused",
	"expiring"
]

const statusLabels: Record<WABAChannelChatCommunicationPermissionStatusOnFilter, string> = {
	active: "Ativa",
	paused: "Inativa",
	expiring: "Prestes a encerrar"
}

const WABACommunicationPermissionFilterCondition: React.FC<WABACommunicationPermissionFilterConditionProps> = (props) => {
	const { condition, onChange } = props

	const handleStatusChange = (status: WABAChannelChatCommunicationPermissionStatusOnFilter) => {
		onChange({
			type: "contact_waba_communication_permission",
			operator: "equal",
			filterData: { status }
		})
	}

	return (
		<Grid container direction="row" spacing={2}>
			<Grid item xs={12}>
				<FormControl fullWidth variant="outlined" size="small">
					<Select
						value={condition.filterData.status}
						onChange={({ target }) =>
							handleStatusChange(target.value as WABAChannelChatCommunicationPermissionStatusOnFilter)
						}
					>
						{ACCEPTED_WABA_COMMUNICATION_PERMISSION_STATUSES.map(status => (
							<MenuItem key={status} value={status}>
								{statusLabels[status]}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	)
}

export default WABACommunicationPermissionFilterCondition
